export default {"src":"/_next/static/media/Legal Data.183f62b4.svg","height":203,"width":352,"blurWidth":0,"blurHeight":0};